<template>
<div>
<CreateStudentAccount/>

</div>
</template>
<script>
import CreateStudentAccount from "../../components/academic/CreateStudentAccount.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   CreateStudentAccount
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>